import SignupRedirect from "./SignupRedirect";

export default SignupRedirect;
